import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        nav: true,
        icon: 'fa fa-home',
        exact: true,
        restrict: { 'user.usertype': { $in: ['C'] } }
      }
    },
    {
      path: '/info',
      name: 'AccountInfo',
      component: () => import('@/views/AccountInfo'),
      meta: {
        nav: true,
        name: 'Account Info',
        icon: 'fa fa-user',
        restrict: { 'user.usertype': { $in: ['C'] } }
      }
    },
    {
      path: '/address-book',
      name: 'AddressBook',
      component: () => import('@/views/AddressBook'),
      meta: {
        nav: true,
        name: 'Address Book',
        icon: 'fa fa-address-book',
        restrict: { 'user.usertype': { $in: ['C'] } }
      }
    },
    {
      path: '/address-book/:addressId',
      name: 'AddressEditor',
      component: () => import('@/views/AddressBook/AddressEditor')
    },
    {
      path: '/orders',
      name: 'Orders',
      component: () => import('@/views/Orders'),
      children: [
        {
          path: '/orders',
          name: 'Orders',
          component: () => import('@/views/Orders/Open')
        },
        {
          path: '/orders/previous',
          name: 'PreviousOrders',
          component: () => import('@/views/Orders/Previous')
        },
        {
          path: '/orders/returns',
          name: 'Returns',
          component: () => import('@/views/Orders/Returns')
        }
      ],
      meta: {
        nav: true,
        name: 'Orders',
        icon: 'fa fa-shipping-fast',
        restrict: { 'user.usertype': { $in: ['C'] } }
      }
    },
    {
      path: '/faq/:faqId',
      name: 'Faq',
      component: () => import('@/views/Faq')
    },
    {
      path: '*',
      component: () => import('@/views/NotFound')
    }
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export { routes }

export default router
